// REDUCER
import * as actionTypes from '../constants/actions';

const defaultState = {
	single: {},
	isFetching: false,
};

function pageReceived(state, payload) {
	state = setBusy(state, false);
	if (typeof payload === 'object' && payload.hasOwnProperty('id')) {
		if (!payload.hasOwnProperty('content')) {
			payload.content = [];
		}

		return {...state, single: payload};
	}

	return state;
}

function setBusy(state, payload = true) {
	return {...state, isFetching: payload};
}

function reqPage(state, payload = true) {
	state = setBusy(state, true);

	return {...state};
}

export default function pageReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.PAGES_RECV_SINGLE_DATA:
			return pageReceived(state, action.payload);
		case actionTypes.PAGES_REQ_SINGLE_DATA:
			return reqPage(state);
		case actionTypes.PAGES_RECV_ERROR:
			return setBusy(state, false);
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/page.js
 **/